/* ATARA core: money, header, drawers, cart */
(function () {
  'use strict';
  var A = window.Atara = window.Atara || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  A.$ = $; A.$$ = $$;

  A.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || A.money || '{{amount}} ₪';
    function fmt(n, dec, ts, ds) {
      var num = (n / 100).toFixed(dec).split('.');
      return num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (num[1] && dec ? ds + num[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', val;
    if (key === 'amount_no_decimals') val = fmt(cents, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') val = fmt(cents, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') val = fmt(cents, 0, '.', ',');
    else val = fmt(cents, 2, ',', '.');
    val = val.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  };

  var toastEl;
  A.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  };
  A.fail = function (err) { A.toast((err && err.description) || A.strings.error); };

  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var announce = $('.announce');
    var overlay = document.body.classList.contains('has-overlay-header');
    var ticking = false;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 10);
      if (overlay) {
        var h = announce ? announce.offsetHeight : 0;
        document.documentElement.style.setProperty('--announce-offset', Math.max(0, h - y) + 'px');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  A.initAnnounce = function () {
    $$('.announce__track').forEach(function (track) {
      if (track._on) return; track._on = true;
      var msgs = $$('.announce__msg', track);
      if (!msgs.length) return;
      msgs[0].classList.add('is-active');
      if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0, speed = (parseInt(track.dataset.speed, 10) || 5) * 1000;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    });
  };

  var backdrop, openEl = null, lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    if (openEl && openEl !== el) closeDrawer();
    if (!backdrop) {
      backdrop = document.createElement('div'); backdrop.className = 'drawer-backdrop';
      backdrop.addEventListener('click', closeDrawer); document.body.appendChild(backdrop);
    }
    lastFocus = document.activeElement;
    backdrop.classList.add('is-open');
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    openEl = el;
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = el.querySelector('[data-drawer-close]');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer() {
    if (!openEl) return;
    var el = openEl;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  A.openDrawer = openDrawer; A.closeDrawer = closeDrawer;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) closeDrawer(); });

  function updateCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function renderCart(sections) {
    var html = sections && sections['cart-drawer'];
    var drawer = document.getElementById('CartDrawer');
    if (!html || !drawer) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    updateCount(fresh.getAttribute('data-item-count'));
  }
  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  A.addItems = function (items) {
    return cartRequest(A.routes.cartAdd + '.js', { items: items }).then(function (res) {
      renderCart(res.sections);
      var d = document.getElementById('CartDrawer');
      if (A.cartType === 'drawer' && d) openDrawer(d); else window.location.href = A.routes.cart;
      return res;
    });
  };
  function changeLine(key, qty) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('is-busy');
    return cartRequest(A.routes.cartChange + '.js', { id: key, quantity: qty })
      .then(function (res) { renderCart(res.sections); })
      .catch(A.fail)
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      var target = document.getElementById(open.getAttribute('data-drawer-open'));
      if (target && !(target.id === 'CartDrawer' && A.cartType !== 'drawer')) { e.preventDefault(); openDrawer(target); }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var lq = e.target.closest('[data-line-qty]');
    if (lq && lq.closest('#CartDrawer')) {
      e.preventDefault();
      changeLine(lq.getAttribute('data-key'), Math.max(0, parseInt(lq.getAttribute('data-line-qty'), 10)));
      return;
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      A.addItems([{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }])
        .catch(A.fail).finally(function () { quick.classList.remove('is-loading'); });
      return;
    }
    var step = e.target.closest('[data-step]');
    if (step) {
      var input = step.parentNode.querySelector('input[type="number"]');
      if (!input) return;
      var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-step'), 10);
      input.value = Math.max(parseInt(input.min || '0', 10), v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    ['MenuDrawer', 'CartDrawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentNode !== document.body) document.body.appendChild(el);
    });
    initHeader();
    A.initAnnounce();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $$('video[autoplay]').forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
    }
  });
})();